import { Directive, Input, OnDestroy } from '@angular/core';
import { TitleService } from '../services/page-title.service';

@Directive({
  selector: '[tdPageTitle]',
  standalone: false,
})
export class PageTitleDirective implements OnDestroy {
  @Input('tdPageTitle') public set pageTitle(title: string) {
    this.titleService.setTitle(title);
  }

  constructor(private titleService: TitleService) {}

  public ngOnDestroy() {
    this.titleService.setTitle(null);
  }
}
